import React from 'react';
import SEO from '../components/SEO';

const ProcessPage = () => {
  const steps = [
    {
      number: '01',
      title: 'Discover',
      description: 'Stakeholder interviews, scope, success metrics, and a measurable plan.'
    },
    {
      number: '02',
      title: 'Design',
      description: 'User flows, wireframes, prototypes, and design systems that scale with your product.'
    },
    {
      number: '03',
      title: 'Build',
      description: 'Agile sprints, CI/CD, code reviews, and infra‑as‑code to ship fast with confidence.'
    },
    {
      number: '04',
      title: 'Launch & Iterate',
      description: 'UAT, rollout plans, observability, and rapid iteration using real customer feedback.'
    }
  ];

  return (
    <div className="pt-24">
      <SEO 
        title="Software Delivery Process for Georgia Businesses | Alpha Consulting LLC"
        description="See how our Atlanta, Georgia team takes software projects from discovery to delivery with agile planning, design, engineering, QA, cloud implementation, and iterative improvement."
        keywords="software development process Atlanta, agile delivery Georgia, product engineering methodology Georgia, software project delivery Atlanta"
        url="https://thealphaconsult.com/process"
        image="https://thealphaconsult.com/3ff0f777-6fef-48b9-81ec-9c3949d95efa_3840.png"
      />
      <section className="relative py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-amber-300/80 font-nunito">
              <span className="w-1.5 h-1.5 rounded-full bg-amber-400"></span> How we work
            </span>
            <h2 className="mt-3 text-3xl sm:text-4xl tracking-tight font-nunito font-bold">
              A proven delivery framework
            </h2>
            <p className="mt-3 text-orange-300 font-nunito">
              Lightweight, outcome‑driven phases keep momentum while reducing risk.
            </p>
          </div>

          <div className="mt-10 grid gap-6 lg:grid-cols-4 sm:grid-cols-2">
            {steps.map((step, index) => (
              <div key={index} className="rounded-2xl border border-white/10 bg-orange-900/40 p-6">
                <div className="text-amber-300 font-nunito text-2xl font-bold">{step.number}</div>
                <h3 className="mt-2 font-semibold font-nunito text-xl">{step.title}</h3>
                <p className="mt-2 text-orange-400 font-nunito">{step.description}</p>
              </div>
            ))}
          </div>

          {/* Additional Process Details */}
          <div className="mt-16 rounded-2xl border border-white/10 bg-gradient-to-b from-orange-900/60 to-orange-900/30 p-8">
            <h3 className="text-2xl font-semibold font-nunito mb-6">Our Approach</h3>
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h4 className="text-lg font-semibold font-nunito text-amber-300 mb-3">Agile & Flexible</h4>
                <p className="text-orange-300 font-nunito">
                  We adapt our process to fit your team's workflow. Whether you prefer weekly sprints or monthly milestones, 
                  we ensure continuous delivery and transparency.
                </p>
              </div>
              <div>
                <h4 className="text-lg font-semibold font-nunito text-amber-300 mb-3">Quality First</h4>
                <p className="text-orange-300 font-nunito">
                  Every line of code is reviewed, tested, and documented. We maintain high standards through automated testing, 
                  code coverage metrics, and peer reviews.
                </p>
              </div>
              <div>
                <h4 className="text-lg font-semibold font-nunito text-amber-300 mb-3">Clear Communication</h4>
                <p className="text-orange-300 font-nunito">
                  Regular standups, sprint reviews, and detailed documentation keep everyone aligned. 
                  You'll always know what's happening and what's coming next.
                </p>
              </div>
              <div>
                <h4 className="text-lg font-semibold font-nunito text-amber-300 mb-3">Long-term Partnership</h4>
                <p className="text-orange-300 font-nunito">
                  We're not just contractors we're your technology partners. Our goal is to build lasting relationships 
                  and help your business grow through excellent software.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProcessPage;
